export type BlockDef = {
  id: string;
  namePl: string;
  priceZl: number;
  category: 'wall' | 'floor' | 'furniture' | 'stable' | 'roof' | 'window';
};

export const BLOCKS: BlockDef[] = [
  { id: 'wall_pink', namePl: 'Ściana różowa', priceZl: 3, category: 'wall' },
  { id: 'wall_mint', namePl: 'Ściana miętowa', priceZl: 3, category: 'wall' },
  { id: 'floor_wood', namePl: 'Podłoga drewniana', priceZl: 2, category: 'floor' },
  { id: 'floor_tile', namePl: 'Kafelki', priceZl: 2, category: 'floor' },
  { id: 'roof_red', namePl: 'Dach czerwony', priceZl: 4, category: 'roof' },
  { id: 'window_round', namePl: 'Okrągłe okno', priceZl: 5, category: 'window' },
  { id: 'sofa_pink', namePl: 'Różowa kanapa', priceZl: 10, category: 'furniture' },
  { id: 'table_wood', namePl: 'Stolik', priceZl: 6, category: 'furniture' },
  { id: 'bed_soft', namePl: 'Mięciutkie łóżko', priceZl: 12, category: 'furniture' },
  { id: 'tv_retro', namePl: 'Telewizor retro', priceZl: 8, category: 'furniture' },
  { id: 'plant_pot', namePl: 'Doniczka', priceZl: 4, category: 'furniture' },
  // stajnia
  { id: 'fence_wood', namePl: 'Płotek drewniany', priceZl: 3, category: 'stable' },
  { id: 'hay_bale', namePl: 'Belka siana', priceZl: 2, category: 'stable' },
  { id: 'horseshoe_deco', namePl: 'Podkowa', priceZl: 5, category: 'stable' },
  { id: 'trough', namePl: 'Koryto', priceZl: 6, category: 'stable' },
];
